import script from "./EnvironmentTopNav.vue?vue&type=script&setup=true&lang=js"
export * from "./EnvironmentTopNav.vue?vue&type=script&setup=true&lang=js"

import "./EnvironmentTopNav.vue?vue&type=style&index=0&id=2443c3fe&lang=postcss&scoped=true"

import exportComponent from "/builds/atlatl-software/atlatl-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2443c3fe"]])

export default __exports__